<template>
  <div>
    <fade-animation>
      <div class="cart-modal" v-if="open" @click="$emit('close')"></div>
    </fade-animation>
    <slidedown-animation>
      <div class="cart-container" v-if="open" ref="scrollWrapper">
        <div class="cart-header">
          <div class="label">已选品种</div>
          <div class="handle" v-if="list.length" @click="$emit('remove')">
            <van-icon name="delete" size="16" />&nbsp;清空
          </div>
        </div>
        <div class="cart-list-wrap">
          <cube-scroll ref="contentScroll" :data="list">
            <div class="cart-list" v-if="list.length">
              <div class="cart-items" v-for="(item,index) in list">
                <div class="item-name">{{item.title}}</div>
                <div class="item-handle">
                  <van-icon name="delete" size="20" @click="onRemove(index,item)" />&nbsp;&nbsp;&nbsp;
                  <van-stepper
                    input-width="50px"
                    @change="onUpdateNum(item)"
                    v-model="item.num"
                    button-size="28px"
                  />
                </div>
              </div>
            </div>
            <div v-else class="errorTip">
              <van-icon name="shopping-cart-o" size="30" />&nbsp;&nbsp;购物车没有任何东西哦！
            </div>
          </cube-scroll>
        </div>
      </div>
    </slidedown-animation>
  </div>
</template> 

<script>
import SlidedownAnimation from "@components/slide/SlidedownAnimation";
import FadeAnimation from "@components/fade/FadeAnimation";
import { CartModel } from "@models/common/cart";
import { ERR_OK } from "@/common";
const cartModel = new CartModel();
export default {
  props: {
    open: Boolean,
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    isUpdateModel: {
      type: Boolean,
      default: true
    }
  },
  components: {
    SlidedownAnimation,
    FadeAnimation
  },
  data() {
    return {
      options: {}
    };
  },
  methods: {
    onRemove(index, data) {
      this.list.splice(index, 1);
      if (this.isUpdateModel) {
        cartModel.removeOne({
          merchid: localStorage.id,
          specid: data.id,
          user_token: localStorage.user_token
        });
        this.$emit("changeNum", {
          item: data,
          isremove: true
        });
      } else {
        this.$emit("changeNum", {
          item: data,
          isremove: true
        });
      }
    },
    onUpdateNum(data = []) {
      //更新购物车数据库数量
      if (this.isUpdateModel) {
        cartModel
          .updateNum({
            data: data,
            merchid: localStorage.id,
            user_token: localStorage.user_token
          })
          .then(res => {
            if (res.code == ERR_OK) {
              this.$emit("changeNum", {
                item: data,
                isremove: false
              });
            }
          });
      } else {
        this.$emit("changeNum", {
          item: data,
          isremove: false
        });
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
>>>.van-stepper__plus {
  background-color: #2196f3;
}

>>> .van-stepper__minus {
  background: red;
}

>>>.van-stepper__minus.van-stepper__minus--disabled {
  background: #f2f3f5;
}

>>>.van-stepper__minus:active {
  background: red;
}

>>>.van-stepper__minus.van-stepper__minus--disabled:active {
  background: #f2f3f5;
}

>>> .van-stepper__plus:active, >>>.van-stepper__plus {
  background-color: #2196f3;
}

>>> {
  &.van-stepper__plus::after, .van-stepper__plus::before {
    background-color: #fff !important;
  }

  &.van-stepper__minus::after, .van-stepper__minus::before {
    background-color: #fff !important;
  }

  .cart-modal {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1001;
  }

  .cart-container {
    position: fixed;
    bottom: 0.9rem;
    height: 60%;
    width: 100%;
    z-index: 1002;
    background: #efefef;
  }

  .cart-list-wrap {
    background: #fff;
    padding: 0.3rem;
    height: calc(100% - 1.5rem);
  }

  .cart-header {
    display: flex;
    justify-content: space-between;
    height: 0.4rem;
    color: #aaa;
    padding: 0.4rem 0.3rem;
    background: #fff;
    align-items: center;
  }

  .cart-header .handle {
    font-size: 0.24rem;
    display: flex;
    align-items: center;
  }

  .cart-list {
  }

  .cart-items {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.4rem;
  }

  .cart-items:last-child {
    margin-bottom: 0;
  }

  .cart-list .item-name {
    font-size: 0.3rem;
  }

  .cart-list .item-handle {
    display: flex;
    align-items: center;
  }

  .errorTip {
    justify-content: center;
    color: #aaa;
    display: flex;
    align-items: center;
    font-size: 0.3rem;
  }
}
</style>